export const GET_TABLE_DATA = "GET_TABLE_DATA";
export const DATA_TABLE_API_SUCCESS = "DATA_TABLE_API_SUCCESS";
export const DATA_TABLE_API_FAIL = "DATA_TABLE_API_FAIL";
export const SET_SELECTED_FILES = "SET_SELECTED_FILES";
export const GET_CHANGING_DATA = "GET_CHANGING_DATA";
export const SET_CHANGING_DATA_RESPONSE ="SET_CHANGING_DATA_RESPONSE";